import type { TranslationResources } from "@project/lib/locales/en";
import careGu from "@project/lib/locales/sections/care.gu";
import programsGu from "@project/lib/locales/sections/programs.gu";
import trustGu from "@project/lib/locales/sections/trust.gu";
import communityGu from "@project/lib/locales/sections/community.gu";
import pagesGu from "@project/lib/locales/sections/pages.gu";
import accountGu from "@project/lib/locales/sections/account.gu";
import csrGu from "@project/lib/locales/sections/csr.gu";

export const gu: TranslationResources = {
  common: {
    siteName: "જીવનધારા વૃદ્ધાશ્રમ",
    tagline: "દરેક વડીલ માટે ગૌરવ, સંભાળ અને કરુણા",
    careCompassionCommunity: "સંભાળ • કરુણા • સમુદાય",
    verified: "પ્રમાણિત",
    certified: "12A • 80G પ્રમાણિત",
    browseCauses: "કારણો જુઓ",
    register: "નોંધણી કરો",
    learnMore: "વધુ જાણો",
  },
  brand: {
    title: "જીવનધારા",
    subtitle: "વૃદ્ધાશ્રમ, લાંભા",
  },
  nav: {
    home: "મુખ્ય",
    about: "અમારા વિશે",
    donation: "દાન",
    csr: "CSR",
    bhojanshala: "ભોજનશાળા",
    events: "પ્રસંગો",
    gaushala: "ગૌશાળા",
    contact: "સંપર્ક",
    more: "વધુ",
    initiatives: "અમારી પહેલ",
  },
  menu: {
    applyAdmission: "પ્રવેશ માટે અરજી કરો",
    residentCare: "નિવાસી સંભાળ",
    elderCareProgram: "વડીલ સંભાળ કાર્યક્રમ",
    healthcare: "આરોગ્ય સંભાળ",
    gaushala: "ગૌશાળા",
    events: "પ્રસંગો",
    gruhUdhyog: "ગૃહ ઉદ્યોગ",
    transparency: "પારદર્શિતા અને અસર",
    tiffinSeva: "ટિફિન સેવા",
    news: "સમાચાર",
    committee: "સમિતિ",
    trustees: "ટ્રસ્ટીઓ",
    gallery: "ગેલેરી",
    visitorForm: "મુલાકાત ફોર્મ",
    feedback: "પ્રતિભાવ",
    jainPanchang: "જૈન પંચાંગ",
  },
  lang: {
    english: "English",
    gujarati: "ગુજરાતી",
    change: "ભાષા બદલો",
  },
  footer: {
    quickLinks: "ઝડપી લિંક",
    services: "અમારી સંભાળ અને સેવા",
    reachUs: "અમારો સંપર્ક",
    rights: "સર્વ હક અમારા સ્વાધીન.",
    aboutUs: "અમારા વિશે",
    residentCare: "નિવાસી સંભાળ",
    donateLink: "દાન",
    events: "દાન પ્રસંગો",
    contact: "સંપર્ક",
    gaushala: "ગૌશાળા",
    bhojanTithi: "ભોજનશાળા",
    tiffinSeva: "ટિફિન સેવા",
    gruhUdhyog: "ગૃહ ઉદ્યોગ",
    address: "પદ્માવતી નગર, ઇન્દિરા નગર વિભાગ-૨, લાંભા, અમદાવાદ – ૩૮૨૪૦૫",
    phone: "+91 9725521170, +91 8758413564, +91 9978015424",
    email: "jivandharavrudhashram@gmail.com",
  },
  home: {
    hero: {
      greeting: "Pranam · प्रणाम · પ્રણામ",
      titleLine1: "દરેક આશ્રમવાસી વડીલ માટે",
      titleLine2: "એક પ્રેમાળ ઘર, રોજેરોજ",
      sanskrit: "मातृ देवो भव : पितृ देवो भव :",
      description:
        "આશ્રય, ભોજન, તબીબી સંભાળ અને ગૌરવ પૂરું પાડતું એક સંપૂર્ણ સેવા પ્લેટફોર્મ — જૈન સમુદાય અને તેનાથી આગળના વડીલો માટે કરુણાથી ઘડાયેલું.",
      feature1: "આજીવન નિવાસી સંભાળ",
      feature2: "12A અને 80G કર લાભ",
      feature3: "1000+ દાતાઓનો વિશ્વાસ",
      admissionApplication: "પ્રવેશ અરજી",
      admissionInquiry: "પ્રવેશ પૂછપરછ",
      watchStory: "અમારી વાર્તા જુઓ",
      services: {
        medicalCentre: "ભગવાન મહાવીર મેડિકલ સેન્ટર",
        tiffin: "ભગવાન મહાવીર વરિષ્ઠ નાગરિક ટિફિન સેવા",
        gaushala: "વૃંદાવન ગીર ગૌશાળા",
        bhojanshala: "ભોજનશાળા",
        mahilaUtkarsh: "મહિલા ઉત્કર્ષ કેન્દ્ર – સદ્ગુણા ગૃહ ઉદ્યોગ",
        donation: "અમારું દાન",
        csr: "કોર્પોરેટ સામાજિક જવાબદારી",
        elderCare: "વડીલ સંભાળ કાર્યક્રમ",
      },
    },
    statsCard: {
      residents: "નિવાસીઓ",
      caredFor: "ની સંભાળ",
      yearsOf: "વર્ષોની",
      seva: "સેવા",
      generous: "ઉદાર",
      donors: "દાતાઓ",
      dailyCare: "દૈનિક સંભાળ",
      medical: "તબીબી",
      shelter: "આશ્રય",
      thisMonth: "આ મહિને",
    },
    trust: {
      heading: "ગુજરાત અને ભારતભરના પરિવારો અને સમુદાયોનો વિશ્વાસ",
      residentsCared: "સંભાળ પામેલા નિવાસીઓ",
      generousDonors: "શુભ ચિંતક",
      wellWishers: "શુભ ચિંતક",
      servicesToSociety: "સમાજ સેવાઓ",
      donationsProcessed: "સમાજ સેવાઓ",
      ofTrustedSeva: "વિશ્વસનીય સેવાનાં",
    },
    admission: {
      badge: "પ્રવેશ પૂછપરછ",
      heading: "શું તમે કોઈ વડીલને અમારા ઘરમાં દાખલ કરવા માંગો છો?",
      description:
        "એક સરળ પ્રવેશ અરજી સબમિટ કરો — અરજદાર, વડીલ અને પરિવારની વિગતો શેર કરો. અમારી ટીમ 3 કાર્યકારી દિવસોમાં તમારો સંપર્ક કરીને આગળનાં પગલાં માટે માર્ગદર્શન આપશે.",
      feature1: "નિ:શુલ્ક પ્રવેશ પૂછપરછ",
      feature2: "ગોપનીય પરિવાર માહિતી",
      feature3: "વ્યક્તિગત ફોલો-અપ કૉલ",
      feature4: "આશ્રમ મુલાકાત અને ઇન્ટરવ્યુ",
      applyButton: "પ્રવેશ પૂછપરછ શરૂ કરો",
      talkButton: "અમારી ટીમ સાથે વાત કરો",
      eldersAdmitted: "દાખલ થયેલા વડીલો",
      howItWorks: "આ કેવી રીતે કાર્ય કરે છે",
      step1: "1. પ્રવેશ પૂછપરછ સબમિટ કરો",
      step2: "2. અમારી ટીમ દ્વારા પ્રારંભિક ટેલિફોનિક સમીક્ષા",
      step3: "3. પરિવાર બેઠક અને ઘર મુલાકાત",
      step4: "4. પ્રવેશ પુષ્ટિ",
    },
    engage: {
      eyebrow: "અમારા પરિવારનો ભાગ બનો",
      heading: "દરેક વડીલ માટે ઘર, દરેક મુલાકાતી માટે આવકાર",
      description:
        "ભલે તમે તમારા પ્રિયજન માટે સંભાળભર્યું ઘર શોધી રહ્યા હો કે અમારા નિવાસીઓની મુલાકાત લેવાનું આયોજન કરી રહ્યા હો, અમારા દરવાજા હંમેશા ખુલ્લા છે. એક સરળ પૂછપરછથી શરૂઆત કરો અને અમારી ટીમ દરેક પગલે તમને માર્ગદર્શન આપશે.",
      cta: "અમારી ટીમ સાથે વાત કરો",
    },
    visitors: {
      badge: "મુલાકાત કનેક્ટ",
      heading: "મુલાકાતની યોજના કરી રહ્યા છો કે તમારો અનુભવ શેર કરી રહ્યા છો?",
      description:
        "તમારી જરૂરિયાતને અનુરૂપ વિકલ્પ પસંદ કરો. આગામી મુલાકાત માટે વિઝિટર ઇન્ક્વાયરી ફોર્મ ભરો અથવા વિઝિટર ફીડબેક ફોર્મ દ્વારા તમારો અનુભવ, પ્રશંસા અને સૂચનો શેર કરો.",
      feature1: "આગામી મુલાકાતની નોંધણી કરો",
      feature2: "તમારી મુલાકાતનો પ્રતિભાવ શેર કરો",
      feature3: "પરિવારની મુલાકાત વિગતો સમર્થિત",
      feature4: "દરેક મુલાકાત સુધારવામાં મદદ કરો",
      applyButton: "મુલાકાત ફોર્મ્સ",
      talkButton: "અમારી ટીમ સાથે વાત કરો",
      visitsLogged: "વાર્ષિક મુલાકાતીઓ",
      howItWorks: "આ કેવી રીતે કાર્ય કરે છે",
      step1: "1. યોગ્ય મુલાકાત ફોર્મ પસંદ કરો.",
      step2: "2. જરૂરી વિગતો પૂર્ણ કરો.",
      step3: "3. તમારી પૂછપરછ અથવા પ્રતિભાવ સબમિટ કરો.",
      step4: "4. અમારી ટીમ સમીક્ષા કરશે અને જરૂર પડે તો જવાબ આપશે.",
    },
    visitorChooser: {
      badge: "મુલાકાત ફોર્મ્સ",
      title: "તમે કેવી રીતે જોડાવા માંગો છો?",
      description:
        "પસંદ કરો કે તમે અગાઉની મુલાકાતનો પ્રતિભાવ આપવા માંગો છો, કે આગામી મુલાકાતની નોંધણી કરવા માંગો છો.",
      feedbackTitle: "મુલાકાતી પ્રતિભાવ ફોર્મ",
      feedbackDescription:
        "જીવનધારાની મુલાકાત બાદ તમારો અનુભવ, સૂચનો અથવા પ્રશંસા શેર કરો.",
      feedbackCta: "પ્રતિભાવ ફોર્મ ખોલો",
      inquiryTitle: "મુલાકાત પૂછપરછ ફોર્મ",
      inquiryDescription:
        "મુલાકાતની યોજના છે? મુલાકાત વિગતો, કારણ અને સંદર્ભ માહિતી શેર કરો.",
      inquiryCta: "પૂછપરછ ફોર્મ ખોલો",
    },
    schemes: {
      eyebrow: "Jivandhara વિશે વધુ",
      heading: "અમારી સેવાઓ જાણો",
      description:
        "કરુણામય સંભાળ, આરોગ્યસેવા, સેવા અને સાંસ્કૃતિક મૂલ્યોના સંરક્ષણ દ્વારા Jivandhara વડીલો અને સમુદાયની કેવી રીતે સેવા કરે છે તે જાણો.",
      residentCareTitle: "નિવાસી સંભાળ",
      residentCareDesc:
        "જાણો કે અમે કેવી રીતે સુરક્ષિત, સંભાળભર્યું અને ગૌરવપૂર્ણ ઘર પૂરું પાડીએ છીએ, જ્યાં દરેક વડીલને પ્રેમ, આદર અને કરુણા સાથે સંભાળ લેવા મા આવે છે.",
      residentCareButton: "સંભાળ જુઓ",
      gaushalaTitle: "વૃંદાવન ગીર ગૌશાળા",
      gaushalaDesc:
        "અમારી ગૌશાળા શોધો, જે સ્થાનિક ગીર ગાયોની સંભાળ અને અમારી સમૃદ્ધ સાંસ્કૃતિક અને આધ્યાત્મિક વિરાસતના સંરક્ષણ માટે સમર્પિત છે.",
      gaushalaButton: "ગૌશાળા જુઓ",
      tiffinTitle: "ટિફિન સેવા",
      tiffinDesc:
        "જરૂરિયાતમંદ નિવાસીઓને ગરમ, ઘરે બનાવેલા ટિફિન પૂરા પાડો.",
      tiffinButton: "નોંધણી કરો",
      healthcareTitle: "આરોગ્યસેવા",
      healthcareDesc:
        "અમારી તબીબી સુવિધાઓ, નિયમિત આરોગ્ય તપાસ, ફિઝિયોથેરાપી અને દરેક નિવાસી માટે કરુણામય આરોગ્યસેવા વિશે જાણો.",
      healthcareButton: "આરોગ્યસેવા જુઓ",
    },
    glimpses: {
      eyebrow: "સેવાની ઝલક",
      heading: "અમારા ઘરની પ્રેમ ભરી ક્ષણો",
      description:
        "સંભાળ, સાથ અને ગૌરવ — માનવસેવામાં રોજેરોજ ઝિલાયેલું.",
      festivalLabel: "ઉત્સવ અને ઉજવણીઓ",
      festivalSub: "Jivandhara ખાતે પવિત્ર ઉત્સવ અને આનંદમય ઉજવણીઓ",
      gaushalaLabel: "ગૌશાળા",
      gaushalaSub: "અમારી વૃંદાવન ગીર ગૌશાળામાં ગાયોની સંભાળ",
      derasarLabel: "દેરાસર",
      derasarSub: "અમારા મંદિરમાં દૈનિક પૂજા અને આધ્યાત્મિક શાંતિ",
      viewGallery: "સંપૂર્ણ ગેલેરી જુઓ",
    },
    testimonials: {
      eyebrow: "વિશ્વાસના સ્વર",
      heading: "અમારા સમર્થકો શું કહે છે",
      description:
        "દાતાઓ, પરિવારો અને સેવા પ્રતિ વિશ્વાસ રાખનાર સુખદાયક શબ્દો.",
    },
    pillars: {
      residentCareTitle: "નિવાસી સંભાળ",
      residentCareBody:
        "દરેક નિવાસી માટે આજીવન આશ્રય, ભોજન, દૈનિક સંભાળ અને સાથ.",
      medicalTitle: "તબીબી સહાય",
      medicalBody:
        "24×7 એમ્બ્યુલન્સ, 24×7 ડૉક્ટરો, દૈનિક દવાઓ, હૉસ્પિટલ જોડાણ અને કટોકટી સંભાળ.",
      ritualsTitle: "વિધિ અને ગૌરવ",
      ritualsBody:
        "જન્મદિવસથી લઈને અંતિમ સંસ્કાર સુધી — દરેક પ્રસંગ આદર સાથે ઊજવાય છે.",
    },
    shloka: {
      sanskrit: "“यत्र वृद्धाः पूज्यन्ते रमन्ते तत्र देवताः”",
      translation: "જ્યાં વૃદ્ધોનું સન્માન થાય, ત્યાં દેવતા વસે છે.",
    },
    cta: {
      headingBefore: "અમારા",
      headingHighlight: "પરિવાર",
      headingAfter: "નો ભાગ બનો",
      description:
        "અતિથિ દેવો ભવ : अतिथि देवो भव — મુલાકાત લો, સ્વયંસેવા કરો, દાન કરો અથવા ફક્ત શેર કરો. દયાનું દરેક કાર્ય અનેકગણું વધે છે.",
      donateNow: "હમણાં દાન કરો",
      visitUs: "અમારી મુલાકાત લો",
    },
    csr: {
      eyebrow: "CSR ભાગીદારી",
      headingBefore: "સામાજિક પ્રભાવ માટે",
      headingHighlight: "અમારી સાથે જોડાઓ",
      description:
        "અગ્રણી કંપનીઓને અમારા CSR ભાગીદાર તરીકે આવકારતાં અમે ગૌરવ અનુભવીએ છીએ, જેઓ અર્થપૂર્ણ પરિવર્તન લાવવા અમારી સાથે હાથ મિલાવે છે. સાથે મળીને આપણે વડીલોની સંભાળ, આરોગ્ય સેવા, પૌષ્ટિક ભોજન, ગૃહ ઉદ્યોગ દ્વારા મહિલા સશક્તિકરણ અને સમુદાય કલ્યાણને ટેકો આપી શકીએ છીએ—દરેક યોગદાનને કાયમી પ્રભાવમાં ફેરવીને.",
      tagline: "કાયમી અને અર્થપૂર્ણ પ્રભાવ માટે હેતુપૂર્ણ ભાગીદારી.",
      contactUs: "અમારો સંપર્ક કરો",
      viewMore: "વધુ જુઓ",
      areaElderCare: "વડીલોની સંભાળ",
      areaHealthcare: "આરોગ્ય સેવા",
      areaMeals: "પૌષ્ટિક ભોજન",
      areaWomen: "મહિલા સશક્તિકરણ",
      areaWomenSub: "ગૃહ ઉદ્યોગ દ્વારા",
      areaCommunity: "સમુદાય કલ્યાણ",
    },
    awards: {
      eyebrow: "સન્માન અને માન્યતા",
      headingBefore: "પુરસ્કારો અને",
      headingHighlight: "સિદ્ધિઓ",
      description:
        "વડીલોની અમારી સેવાને અગ્રણી મીડિયા અને નાગરિક સંસ્થાઓએ બિરદાવી છે — દરેક સન્માન અમારા વડીલો, દાતાઓ અને સ્વયંસેવકોનું છે.",
      a1Title: "ઇમર્જિંગ ગુજરાત 2023 એવોર્ડ",
      a1Desc: "TV9 ગુજરાતી દ્વારા જીવનધારા વૃદ્ધાશ્રમને એનાયત.",
      a1Tag: "2023",
      a2Title: "ધ રાઇઝ એન્ડ રાઇઝ ઓફ ઇન્ડિયા ઇન્ક. – ભારત@75",
      a2Desc: "TV9 ગુજરાતી દ્વારા જીવનધારા વૃદ્ધાશ્રમને એનાયત.",
      a2Tag: "ભારત@75",
      a3Title: "બિઝનેસ આઇકોન્સ 2022 એવોર્ડ",
      a3Desc: "શ્રી સંદીપ શાહ, જીવનધારા વૃદ્ધાશ્રમનું સન્માન.",
      a3Tag: "2022",
      a4Title: "સમાજ સેવામાં પ્રાઇડ ઓફ અમદાવાદ એક્સેલન્સ એવોર્ડ",
      a4Desc: "જીવનધારા વૃદ્ધાશ્રમને એનાયત કરાયેલ પુરસ્કાર.",
      a4Tag: "સમાજ સેવા",
    },
    upcoming: {
      eyebrow: "આગામી પ્રોજેક્ટ્સ",
      headingBefore: "સેવાનો",
      headingHighlight: "નવો અધ્યાય",
      description:
        "આપના આશીર્વાદ અને સહયોગથી જીવનધારા હવે આગળનું મોટું પગલું ભરી રહ્યું છે — વડીલો માટે વિશાળ નિવાસ તથા સારવાર અને પુનર્વસન માટેના સમર્પિત કેન્દ્રો.",
      years: "૨૦૨૭–૨૦૨૮",
      comingSoon: "ટૂંક સમયમાં",
      catElderCare: "વડીલ સેવા",
      catHospital: "હોસ્પિટલ",
      catCancerCare: "કેન્સર કેર",
      catRehab: "પુનર્વસન",
      ctaButton: "પ્રોજેક્ટમાં સહયોગ આપો",
    },
  },
  csrPage: {
    hero: {
      eyebrow: "CSR ભાગીદારી",
      title: "કોર્પોરેટ સામાજિક જવાબદારી (CSR)",
      subtitle:
        "અમારા સહયોગી ટ્રસ્ટ CSR પ્રવૃત્તિઓ માટે કોર્પોરેટ બાબતોના મંત્રાલયમાં નોંધાયેલા છે. કાયમી સામાજિક પ્રભાવ માટે અમારી સાથે જોડાઓ.",
    },
    intro: {
      eyebrow: "અમારી સાથે શા માટે જોડાવું",
      heading: "તમારી CSR પ્રતિબદ્ધતાને ફેરવો",
      headingHighlight: "અર્થપૂર્ણ પરિવર્તનમાં",
      highlight1Title: "ઝડપી ભંડોળ ઉપયોગ",
      highlight1Text:
        "દરેક રૂપિયો સીધો મફત આશ્રય, ભોજન અને વડીલોની સંભાળ માટે વપરાય છે. સરળ CSR અનુપાલન માટે ઉપયોગ પ્રમાણપત્રો અને પ્રભાવ અહેવાલ આપવામાં આવે છે.",
      highlight2Title: "જમીની સ્તરે પ્રભાવ",
      highlight2Text:
        "ભોજનશાળાના ભોજન અને ગૌશાળાની સંભાળથી લઈને ગૃહ ઉદ્યોગની આજીવિકા સુધી, આપનું યોગદાન અમારા લાંભા કેમ્પસ પરના કાર્યક્રમોને શક્તિ આપે છે — કોઈ વચેટિયા વગર અને સંપૂર્ણ પારદર્શિતા સાથે.",
      highlight3Title: "તબીબી સહાય",
      highlight3Text:
        "આપનું યોગદાન અમારા વડીલ નિવાસીઓ અને ગૌશાળામાં આશ્રિત ગાયો માટે નિયમિત આરોગ્ય તપાસ, કટોકટી સારવાર અને દવાઓ માટે ઉપયોગી થાય છે.",
    },
    benefits: {
      eyebrow: "આ શા માટે મહત્વનું છે",
      heading: "આપની કંપનીને મળતા લાભો",
      subtitle:
        "જીવનધારા સાથેની ભાગીદારી આપની કંપનીને CSR જવાબદારીઓ પૂર્ણ કરવામાં મદદ કરે છે અને લોકોના જીવનમાં વાસ્તવિક પરિવર્તન લાવે છે.",
      cta: "CSR ભાગીદાર બનો",
      item1Title: "સંપૂર્ણ CSR અનુરૂપ",
      item1Text:
        "વડીલોની સંભાળ, આરોગ્ય સેવા, ભૂખ નિવારણ, મહિલા સશક્તિકરણ અને પશુ કલ્યાણ કંપની અધિનિયમ, 2013 ના શેડ્યૂલ VII હેઠળ માન્ય છે — અમારા MCA નોંધાયેલ (CSR-1) સહયોગી ટ્રસ્ટ દ્વારા અમલ.",
      item2Title: "પારદર્શક, માપી શકાય તેવો પ્રભાવ",
      item2Text:
        "કેટલા વડીલોને આશ્રય મળ્યો, કેટલું ભોજન પીરસાયું અને કેટલી સારવાર થઈ તે દર્શાવતા ઉપયોગ પ્રમાણપત્રો, પ્રભાવ અહેવાલ અને ફોટો દસ્તાવેજીકરણ મેળવો — આપના બોર્ડ અને વાર્ષિક CSR જાહેરાત માટે તૈયાર.",
      item3Title: "કર્મચારી સહભાગિતા",
      item3Text:
        "આપની ટીમને અર્થપૂર્ણ સ્વયંસેવાની તક આપો — વડીલો સાથે સમય વિતાવો, ભોજન પીરસો અથવા અમારા લાંભા કેમ્પસ પર ગૌશાળા સેવામાં જોડાઓ.",
      item4Title: "બ્રાન્ડ પ્રતિષ્ઠા",
      item4Text:
        "આપની બ્રાન્ડને કરુણાપૂર્ણ, પાયાના સ્તરની સામાજિક સેવા સાથે જોડીને ગ્રાહકો અને સમુદાયનો વિશ્વાસ મેળવો.",
    },
    certificates: {
      eyebrow: "નોંધણી",
      heading: "CSR નોંધણી પ્રમાણપત્રો",
      subtitle:
        "ભારત સરકારના કોર્પોરેટ બાબતોના મંત્રાલય હેઠળ રજિસ્ટ્રાર ઑફ કંપનીઝની કચેરી દ્વારા જારી કરાયેલ મંજૂરી પત્રો.",
      registrationNo: "CSR નોંધણી નંબર",
      pan: "PAN",
      dated: "તારીખ",
      srn: "અરજી SRN",
      issuedBy: "જારીકર્તા",
      address: "નોંધાયેલ સરનામું",
      view: "જુઓ",
      download: "ડાઉનલોડ",
      previewAlt: "CSR નોંધણી પ્રમાણપત્રનું પૂર્વાવલોકન",
    },
    cta: {
      heading: "સાથે મળીને પરિવર્તન લાવવા તૈયાર છો?",
      text: "તમારી વિગતો શેર કરો, તમારા લક્ષ્યોને અનુરૂપ CSR ભાગીદારી માટે અમારી ટીમ તમારો સંપર્ક કરશે.",
      button: "અમારો સંપર્ક કરો",
    },
    modal: {
      badge: "CSR પૂછપરછ",
      title: "અમારી સાથે જોડાઓ",
      subtitle:
        "તમારી વિગતો શેર કરો, CSR સહયોગ અંગે ચર્ચા કરવા અમારી ટીમ તમારો સંપર્ક કરશે.",
      fullName: "પૂરું નામ",
      companyName: "કંપની / સંસ્થા",
      mobile: "મોબાઇલ નંબર",
      email: "ઇમેઇલ સરનામું",
      area: "રસનું ક્ષેત્ર",
      areaPlaceholder: "ક્ષેત્ર પસંદ કરો",
      areaAny: "કોઈપણ ક્ષેત્ર",
      message: "સંદેશ",
      messagePlaceholder: "તમારા CSR લક્ષ્યો, બજેટ અથવા સમયરેખા વિશે જણાવો...",
      submit: "પૂછપરછ મોકલો",
      submitting: "મોકલી રહ્યા છીએ…",
      successTitle: "સંપર્ક કરવા બદલ આભાર!",
      successMessage:
        "અમને તમારી CSR પૂછપરછ મળી ગઈ છે. અમારી ટીમ ટૂંક સમયમાં તમારો સંપર્ક કરશે.",
      close: "બંધ કરો",
      nameRequired: "કૃપા કરીને તમારું પૂરું નામ દાખલ કરો",
      companyRequired: "કૃપા કરીને કંપની અથવા સંસ્થાનું નામ દાખલ કરો",
      mobileInvalid: "પસંદ કરેલા દેશ માટે માન્ય મોબાઇલ નંબર દાખલ કરો.",
      error: "તમારી પૂછપરછ મોકલી શકાઈ નહીં. કૃપા કરીને ફરી પ્રયાસ કરો.",
    },
  },
  care: careGu,
  programs: programsGu,
  trust: trustGu,
  community: communityGu,
  pages: pagesGu,
  account: accountGu,
  csr: csrGu,
};
